document.addEventListener("DOMContentLoaded", () => {
    const path = window.location.pathname || "";
    const segments = path.split("/").filter(Boolean);
    const firstSegment = (segments[0] || "").toLowerCase();

    const langMap = new Map([
        ["en", "en-GB"],
        ["cym", "cy-GB"],
        ["cy", "cy-GB"],
    ]);

    const lang = langMap.get(firstSegment) || "en-GB"; // default if no language segment present

    document.documentElement.setAttribute("lang", lang);
});